// Import all model groups
import { dragonProste } from './dragon-proste'
import { dragonProsteAku } from './dragon-proste-aku'
import { dragonPortal } from './dragon-portal'
import { dragonNarozne } from './dragon-narozne'
import { dragonNarozneAku } from './dragon-narozne-aku'
import { dragonTrojstronne } from './dragon-trojstronne'
import { dragonVisAVis } from './dragon-vis-a-vis'
import { dragonVisAVisAku } from './dragon-vis-a-vis-aku'
import { dragonPolokragle } from './dragon-polokragle'
import { nemoProste } from './nemo-proste'
import { nemoNarozne } from './nemo-narozne'
import { nemoVisAVis } from './nemo-vis-a-vis'

import type { ModelsData } from '../../types'

// Combine all model data
export const modelsData: ModelsData = {
  'dragon-proste': dragonProste,
  'dragon-proste-aku': dragonProsteAku,
  'dragon-portal': dragonPortal,
  'dragon-narozne': dragonNarozne,
  'dragon-narozne-aku': dragonNarozneAku,
  'dragon-trojstronne': dragonTrojstronne,
  'dragon-vis-a-vis': dragonVisAVis,
  'dragon-vis-a-vis-aku': dragonVisAVisAku,
  'dragon-polokragle': dragonPolokragle,
  'nemo-proste': nemoProste,
  'nemo-narozne': nemoNarozne,
  'nemo-vis-a-vis': nemoVisAVis
}

// Export individual groups for direct access if needed
export {
  dragonProste,
  dragonProsteAku,
  dragonPortal,
  dragonNarozne,
  dragonNarozneAku,
  dragonTrojstronne,
  dragonVisAVis,
  dragonVisAVisAku,
  dragonPolokragle,
  nemoProste,
  nemoNarozne,
  nemoVisAVis
}
